import React from 'react';
import styled from 'styled-components';
import { JRCIcon } from '../JRCIcon/JRCIcon';

const Container = styled.div`
    display: flex;
    flex-direction: column;
`;

const Header = styled.div`
    display: flex;
    gap: ${({ theme }) => theme.space.l}px;
    align-items: center;
    justify-content: space-between;

    &:hover {
        cursor: pointer;
    }
`;

const Content = styled.div<{ expanded: boolean; maxHeight?: number }>`
    max-height: ${({ expanded, maxHeight }) => (expanded ? (maxHeight ? maxHeight + 'px' : '100%') : 0)};
    overflow: ${({ expanded }) => (expanded ? 'visible' : 'hidden')};
    ${({ maxHeight }) => maxHeight && 'transition: max-height 0.5s;'}
`;

const ContentWrapper = styled.div`
    padding-top: ${({ theme }) => theme.space.md}px;
`;

export type JRCCollapseProps = {
    header: React.ReactNode;
    content: React.ReactNode;
    maxHeight?: number;
    openByDefault?: boolean;
};

export const JRCCollapse = (props: JRCCollapseProps) => {
    const [isOpen, setIsOpen] = React.useState(!!props?.openByDefault);

    return (
        <Container>
            <Header role={'button'} aria-expanded={isOpen} onClick={() => setIsOpen((prev) => !prev)}>
                <div>{props.header}</div>
                <JRCIcon name={isOpen ? 'icon-angle-up' : 'icon-angle-down'} />
            </Header>
            <Content expanded={isOpen} maxHeight={props.maxHeight}>
                <ContentWrapper>{props.content}</ContentWrapper>
            </Content>
        </Container>
    );
};
